import React, { useState } from "react";
import Close from "@mui/icons-material/Close";

type LanguageBarProps = {
  languageName: string;
  languageNameColor: string;
  languageNameUppercase?: boolean;
  iconColor: string;
  barBackgroundColor: string;
  languagesColor: string;
  changeLanguageTextColor?: string;
  changeLanguageText?: string;
  languagesArray: Array<any>;
  closeIconColor?: string;
  closeIconSize?: number;
  borderRadius: boolean;
  showCloseIcon?: boolean;
  showChangeLanguageText?: boolean;
  showArrowIcon?: boolean;
  invertArrow?: boolean;
  showGlobeIcon?: boolean;
  triangleCustomStyle?: Object;
  insideTriangle?: Object;
  langContainerCustomStyle?: Object;
};

export const LanguageBar: React.FunctionComponent<LanguageBarProps> = (props: LanguageBarProps) => {
  const {
    languageName,
    iconColor,
    barBackgroundColor,
    languagesColor,
    changeLanguageTextColor,
    changeLanguageText,
    languagesArray,
    closeIconColor,
    closeIconSize,
    languageNameColor,
    showCloseIcon,
    showChangeLanguageText,
    showArrowIcon,
    invertArrow = false,
    languageNameUppercase,
    showGlobeIcon,
    triangleCustomStyle,
    langContainerCustomStyle,
    insideTriangle,
  } = props;

  const [show, setShow] = useState(false);

  const handlerOpenBar = () => {
    setShow(true);
  };

  const handlerCloseBar = () => {
    setShow(false);
  };

  return (
    <nav
      style={{
        position: "relative",
        zIndex: 9999999,
        width: "max-content",
      }}
    >
      <div
        style={{
          display: "flex",
          position: "relative",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            cursor: "pointer",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
          onClick={handlerOpenBar}
        >
          <span
            style={{
              cursor: "pointer",
              color: languageNameColor,
              paddingRight: "0.5rem",
              textTransform: languageNameUppercase ? "uppercase" : "none",
              fontSize: "0.8vw",
            }}
          >
            {languageName}
          </span>

          {showArrowIcon && (
            <svg
              style={{
                paddingRight: "0.5rem",
                transform: invertArrow ? "scale(1,-1)" : "",
              }}
              width="0.9vw"
              height="0.4vw"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 9 7"
            >
              <path
                id="Polygon_34"
                data-name="Polygon 34"
                d="M4.5,0,9,7H0Z"
                transform={`${show ? "translate(9 7) rotate(180)" : ""}`}
                fill={iconColor}
              />
            </svg>
          )}

          {showGlobeIcon && (
            <svg xmlns="http://www.w3.org/2000/svg" width="0.9vw" height="0.9vw" viewBox="0 0 23.907 23.907">
              <path
                id="web_2_"
                data-name="web(2)"
                d="M19.165,16.344a19.741,19.741,0,0,0,.167-2.391,19.741,19.741,0,0,0-.167-2.391h4.04a9.35,9.35,0,0,1,0,4.781M17.049,22.99a18.706,18.706,0,0,0,1.65-4.255h3.526a9.6,9.6,0,0,1-5.176,4.255m-.3-6.646H11.156a15.037,15.037,0,0,1,0-4.781H16.75a17.434,17.434,0,0,1,.191,2.391,17.587,17.587,0,0,1-.191,2.391m-2.8,7.124a16.212,16.212,0,0,1-2.283-4.734h4.566a16.212,16.212,0,0,1-2.283,4.734M9.172,9.172H5.682a9.471,9.471,0,0,1,5.164-4.255A20.6,20.6,0,0,0,9.172,9.172m-3.49,9.563h3.49a20.6,20.6,0,0,0,1.673,4.255,9.572,9.572,0,0,1-5.164-4.255M4.7,16.344a9.35,9.35,0,0,1,0-4.781h4.04a19.741,19.741,0,0,0-.167,2.391,19.742,19.742,0,0,0,.167,2.391M13.953,4.427a16.279,16.279,0,0,1,2.283,4.745H11.67a16.279,16.279,0,0,1,2.283-4.745m8.272,4.745H18.7a18.706,18.706,0,0,0-1.65-4.255,9.547,9.547,0,0,1,5.176,4.255M13.953,2A11.953,11.953,0,1,0,25.907,13.953,11.965,11.965,0,0,0,13.953,2Z"
                transform="translate(-2 -2)"
                fill={iconColor}
              />
            </svg>
          )}
        </div>
        {show ? (
          <div
            style={{
              position: "absolute",
              top: "0.4vw",
            }}
          >
            <div
              onClick={() => handlerCloseBar()}
              style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 99999998,
              }}
            ></div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                // top: 0,
                top: "0.54vw",
                left: 0,
                width: "100%",
                height: "0.45vw",
                // transform: "translate(0%,-50%)",
                zIndex: 999999999,
              }}
            >
              <div
                style={{
                  zIndex: "999999999",
                  ...triangleCustomStyle,
                }}
              >
                <div style={insideTriangle} />
              </div>
            </div>

            <div
              style={{
                position: "relative",
                background: barBackgroundColor,
                zIndex: 99999999,
                ...langContainerCustomStyle,
              }}
            >
              <ul
                style={{
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                  position: "relative",
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "auto",
                  rowGap: "0.4vw",
                  paddingBottom: showChangeLanguageText ? "0.5rem" : "",
                }}
              >
                {/* {showCloseIcon && (
                  <Close
                    onClick={handlerCloseBar}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      zIndex: 10,
                      cursor: "pointer",
                      color: closeIconColor,
                      fontSize: `${closeIconSize + "rem"}`,
                    }}
                  />
                )} */}
                {/* {showChangeLanguageText && (
                  <h4
                    style={{
                      color: changeLanguageTextColor,
                      margin: 0,
                      marginTop: "0.25rem",
                      marginBottom: "0.5rem",
                      marginRight: "1.5rem",
                      textAlign: "left",
                      fontSize: "0.9rem",
                      textTransform: "capitalize",
                    }}
                  >
                    {changeLanguageText}
                  </h4>
                )} */}
                {languagesArray.map((language) => (
                  <li
                    key={language.name}
                    style={{
                      position: "relative",
                      textAlign: showChangeLanguageText ? "left" : "center",
                      background: "transparent",
                      zIndex: "2",
                      color: languagesColor,
                      fontSize: "0.8vw",
                    }}
                  >
                    <span
                      onClick={() => {
                        language.function();
                        setShow(false);
                      }}
                      style={{ cursor: "pointer", fontSize: "0.8vw" }}
                    >
                      {language.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : null}
      </div>
    </nav>
  );
};
